import {
  IconUsers,
  IconHome,
  IconBookmark,
  IconLayoutGrid,
  IconStack2,
  IconCategory,
  IconFolder
} from '@tabler/icons-react'
import { useSelector } from 'react-redux'
import { Role } from '../../utility/types'

export const useHorizontalLayout = () => {
  const { roles } = useSelector((state) => state.userContextReducer.userContext)
  const isAdmin = roles?.includes(Role.Admin)
  const isContributor = roles?.includes(Role.Contributor)

  const horizontalNavItems = [
    {
      id: 'dashboard',
      title: 'Dashboard',
      icon: <IconHome size={20} />,
      badge: 'light',
      badgeText: '2',
      navLink: '/app-store',
      tourClass: 'dashboard-tour'
    },
    {
      id: 'myspace',
      title: 'My space',
      icon: <IconBookmark size={20} color="var(--color-secondary)" />,
      navLink: '/myspace',
      tourClass: 'myspace-tour'
    },
    {
      id: 'allApps',
      title: 'All applications',
      icon: <IconStack2 size={20} />,
      navLink: '/all-applications'
    },
    {
      header: 'Quick Start'
    },
    {
      id: 'categories',
      title: 'Categories',
      icon: <IconCategory size={20} />,
      navLink: '/categories',
      tourClass: 'categories-tour'
    },
    {
      id: 'collections',
      title: 'Collections',
      icon: <IconFolder size={20} />,
      navLink: '/collections',
      tourClass: 'collections-tour'
    },
    ...(isAdmin || isContributor
      ? [
          {
            header: 'Admin Tools'
          },
          //removed for v1
          // {
          //   id: 'analytics',
          //   title: 'Usage analytics',
          //   icon: <PieChart size={20} />,
          //   navLink: '/analytics',
          //   tourClass: 'analytics-tour'
          // },
          {
            id: 'applications',
            title: 'Applications',
            icon: <IconLayoutGrid size={20} />,
            navLink: '/applications',
            tourClass: 'analytics-tour'
          },
          {
            id: 'notifications',
            title: 'Notifications',
            icon: <IconUsers size={20} />,
            navLink: '/notification-groups'
          }
        ]
      : [])
  ]

  return { horizontalNavItems }
}
